import { money } from "../../lib/cart";
import { statusLabel } from "../../lib/orders";

const Field = ({ label, children }) => (
  <div>
    <p className="text-[10px] uppercase tracking-[0.2em] text-[#5E6B51]">{label}</p>
    <div className="text-sm mt-1 text-[#5A433B]">{children}</div>
  </div>
);

export const OrderDetail = ({ o }) => {
  const a = o.shipping_address || {};
  return (
    <div className="grid md:grid-cols-3 gap-6 p-6 bg-[#F4EBDD]" data-testid={`order-detail-${o.id}`}>
      <Field label="Customer">
        {o.customer_name}<br />
        <a href={`mailto:${o.customer_email}`} className="underline">{o.customer_email}</a>
        {o.customer_phone && <><br />{o.customer_phone}</>}
      </Field>
      <Field label="Delivery">
        <span data-testid={`order-delivery-${o.id}`}>{o.delivery_method === "meetup" ? "Local Meetup (free)" : "Ship My Order ($8)"}</span>
        {o.delivery_method === "meetup" ? (
          <><br />Area: <strong data-testid={`order-meetup-area-${o.id}`}>{o.meetup_area || "Not chosen"}</strong><br />Coordinate by phone: <strong data-testid={`order-meetup-phone-${o.id}`}>{o.customer_phone}</strong></>
        ) : (
          <><br />{a.line1}{a.line2 ? `, ${a.line2}` : ""}<br />{a.city}, {a.state} {a.zip}<br />{a.country}</>
        )}
      </Field>
      <Field label="Payment">
        Preference: <span data-testid={`order-pref-${o.id}`}>{o.payment_preference_label || "Not specified"}</span><br />
        {o.payment_handle && <>Customer account: <span data-testid={`order-handle-${o.id}`}>{o.payment_handle}</span><br /></>}
        Subtotal: {money(o.subtotal_cents)} · Shipping: {money(o.shipping_cents || 0)}<br />
        Total: <strong>{money(o.total_cents || o.subtotal_cents)}</strong><br />
        {o.paid_confirmed_at ? `Confirmed paid ${new Date(o.paid_confirmed_at).toLocaleString()}` : "Not confirmed paid"}
      </Field>
      <Field label="Items">
        {o.items.map((i) => (
          <div key={i.product_id}>{i.name} ({i.size}) × {i.quantity} — {money(i.unit_price_cents * i.quantity)}</div>
        ))}
      </Field>
      <Field label="Status history">
        {(o.status_history || []).map((h, idx) => (
          <div key={idx} className="text-xs">{statusLabel(h.status)} · {new Date(h.at).toLocaleString()}{h.by === "customer" ? " · customer" : " · admin"}</div>
        ))}
      </Field>
      <Field label="Emails">
        {(o.emails || []).length === 0 ? <span className="text-xs text-[#5E4D5A]">None recorded yet</span> : o.emails.map((e, idx) => (
          <div key={idx} className="text-xs">{e.kind.replace("_", " ")} → {e.to}: {e.status.replaceAll("_", " ")}</div>
        ))}
        <div className="text-xs text-[#5E4D5A] mt-1">Researcher ack: {o.researcher_ack?.institution || "no institution"} · policy v{o.researcher_ack?.policy_version}</div>
      </Field>
    </div>
  );
};
